<div class="brand">
  <img
    src="../../../assets/header-bp.svg"
    width="{{ width }}"
    height="{{ height }}"
    alt="Logo Pichincha"
  />
</div>
